import { Component, Input } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contact-us-popover',
  templateUrl: './contact-us-popover.component.html',
  styleUrls: ['./contact-us-popover.component.scss'],
})
export class ContactUsModalComponent {
  @Input() contactUsPopover!: NgbPopover;

  constructor() { }
}
